<div class="f-16 fw-500" style="border-bottom: 1px solid#d8d8d8 !important; margin-bottom: 16px">
  <div class="d-flex justify-content-between mb-1">
    <div>
      {{ "Order #:" | translate | async }}<b> {{ paymentReceipt.orderId.orderNumber }}</b>
    </div>
    <div *ngIf="paymentReceipt.createdAt == 0">---------</div>
    <div *ngIf="paymentReceipt.createdAt != 0" class="text-uppercase">
      {{ convertDate(paymentReceipt.createdAt) | translate | async }}
    </div>
  </div>
  <div class="d-flex justify-content-between mb-1">
    <div>
      <!-- Check ID :<b> {{ paymentReceipt.payId }}</b> -->


      <ng-container *ngIf="paymentReceipt.orderId.isOffline == 0">
        <div>{{ "Check ID :" | translate | async }} <b>{{ paymentReceipt.paymentNumber }}</b></div>
       </ng-container>

       <ng-container *ngIf="paymentReceipt.orderId.isOffline != 0">
        <div>{{ "Check ID :" | translate | async }} <b>{{ paymentReceipt.orderId.offlineOrderNumber }}</b></div>
       </ng-container>

      </div>
    <div>{{ time | translate | async }}</div>
  </div>
  <div class="mb-1" *ngIf="paymentReceipt.orderId.customerFirstName || paymentReceipt.orderId.customerLastName">
    {{ "Customer Name :" | translate | async }}
    <b>{{ paymentReceipt.orderId.customerFirstName }}
      {{ paymentReceipt.orderId.customerLastName }}</b>
  </div>
  <div class="mb-1" *ngIf="paymentReceipt.orderId.serverId === null">
    {{ "Customer Name :" | translate | async }} <b>{{ "No Customer" | translate | async }}</b>
  </div>
  <div>
    <div *ngIf="paymentReceipt?.orderId?.vehicleDetails?.vehicleNumber" class="d-flex justify-content-between mb-2">
      <div>
        {{ "Vehicle Number:" | translate | async }}<b>
          {{ paymentReceipt?.orderId?.vehicleDetails?.vehicleNumber }}</b>
      </div>
    </div>
    <div *ngIf="paymentReceipt?.orderId?.vehicleDetails?.vehicleType" class="d-flex justify-content-between mb-2">
      <div>
        {{ "Vehicle Type :" | translate | async }}<b> {{ paymentReceipt?.orderId?.vehicleDetails?.vehicleType | translate | async }}</b>
      </div>
    </div>
    <div *ngIf="paymentReceipt?.orderId?.vehicleDetails?.vehicleColor" class="d-flex justify-content-between mb-2">
      <div>
        {{ "Vehicle Color:" | translate | async }}<b> {{ paymentReceipt?.orderId?.vehicleDetails?.vehicleColor | translate | async }}</b>
      </div>
    </div>
    <div *ngIf="paymentReceipt?.orderId?.vehicleDetails?.vehicleBrand" class="d-flex justify-content-between mb-2">
      <div>
        {{ "Vehicle Brand :" | translate | async }}<b>
          {{ paymentReceipt?.orderId?.vehicleDetails?.vehicleBrand }}</b>
      </div>
    </div>
  </div>
  <div class="mb-1" *ngIf="paymentReceipt.orderId.serverId !== null">
    {{ "Employee Name :" | translate | async }}
    <b>{{ paymentReceipt?.orderId?.serverId?.employeeFirstName }}
      {{ paymentReceipt?.orderId?.serverId?.employeeLastName }}</b>
  </div>
  <div class="mb-1" *ngIf="paymentReceipt.orderId.serverId === null">
    {{ "Employee Name :" | translate | async }} <b></b>
  </div>
</div>
